const firstCharToUpper = (title) => title.charAt(0).toUpperCase() + title.slice(1)

export const adjustTitleFromSlug = (title, div = '-', rep = ' ') => {
    let capitalized = firstCharToUpper(title)

    if ( capitalized.indexOf(div) > 0 ) {
        capitalized = [...capitalized.split(div)].map((word) => {
            return firstCharToUpper(word)
        })
        capitalized = capitalized.join(rep)
    }

    return capitalized
}

export const adjustSlugFromTitle = (title) => {
    
    return title
        .replace(/\s/g, '-')
        .replace('&rsquo;', '')
        .replace(/&/g, 'and')
        .replace(/'re/g, '-are')
        .toLowerCase()
}

export const adjustStorySlugByPath = (slug, path) => {
    const dir = path.slice(1).startsWith('discover')
        ? 'discover-your-purple'
        : 'how-we-recruit-1'

    return `/${dir}/${slug}`
}